import styled from "styled-components";
import { Atom } from 'AppReact';

const Title = styled.div`
    font-size: 16px;
    line-height: 14px;
    letter-spacing: 0.1px;
    margin-right: 25px;
    text-align: center;
    color: #000000;
    font-weight: 600;
    margin-bottom: 10px;

    @media only screen and (min-width: 768px) {
      font-size: 28px;
      line-height: 20px;
    }
`;

export default Atom({ type: 'label', dataType: 'string', template: Title });
